function t(r) {
  return typeof r == "object" && r !== null && !Array.isArray(r);
}
export {
  t as isObject
};
